import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitLanding(props) {
  const {isOpen, toggle} = useExitIntent(30000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-landing" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading">Checking in…</h4>
          <p>
            You’re about to pass up watching <br className="d-none d-lg-block d-xl-none" />
            the <br className="d-none d-sm-block d-lg-none" />
            special event edition of <i>Fantastic Fungi</i> — with <br className="d-none d-sm-block d-lg-none" />
            new footage — and 20 mushroom recipes?
          </p>
          <p>
            It’s not too late to change your <br className="d-none d-sm-block" />
            mind and get it all for free!
          </p>
          <Row className="d-flex align-items-center mt-5">
            <Col xs="12" lg="6" className="mb-4 mb-lg-0">
              <Button
                className="text-uppercase text-white btn-exit-orange btn-exit-orange-landing"
                color="cta-ff"
                onClick={toggle}
                block
              >
                Take me to <br className="d-none d-lg-block" />
                the movie!
              </Button>
            </Col>
            <Col xs="12" lg="6">
              <Button className="text-uppercase text-white" color="exit-gray-ff" onClick={toggle} block>
                No thanks, <br className="d-none d-lg-block" />
                I’d rather pay <br className="d-none d-lg-block" />
                for movies
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs="12" lg="5" className="landing-exit-image-col background-ff-cream order-lg-1 d-flex flex-column">
          <div className="my-auto px-3 px-lg-1 py-5">
            <img src="https://cdn.foodrevolution.org/ff/FF-Product-Image-Laptop.png" />
          </div>
        </Col>
      </Row>
    </Modal>
  );
}
